<!-- 赌神排行榜 游戏币 -->
<template>
<el-dialog
    class="ball-style"
    :visible.sync="status"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    >
    <div class="ball-cup-container">
        <div class="close" @click="closeHandler"><img :src="require('../assets/close.png')" width="32" alt=""></div>
        <div class="win-cup"><img :src="require('../assets/big-rank-cup.png')" alt=""></div>
        <div class="title-text">
            <div class="main"><img :src="require('../assets/gamblers-ran.png')" alt=""> </div>
            <div class="subf">按照盈利金额排行</div>
        </div>
        <ul class="list">
            <li v-for="(item,index) in listArray" :key="index">
                <div class="order" v-if="index == 0"><img :src="require('../assets/top1.png')" alt=""></div>
                <div class="order" v-else-if="index == 1"><img :src="require('../assets/top2.png')" alt=""></div>
                <div class="order" v-else-if="index == 2"><img :src="require('../assets/top3.png')" alt=""></div>
                <div class="order" v-else>{{index+1}}</div>
                <div class="user-avatar"><img :src="item.avatar" alt=""></div>

                <div class="flex-cont">
                    <div class="user-name">{{item.username}}</div>
                    <div class="join-total">下注{{item.totalCount}}次</div>
                </div>
                <div class="self" v-if="user.id == item.a8userId">本人</div>
                <div class="total-count">
                    盈利{{item.delta}} <img :src="require('../assets/gold-small.png')" alt="" height="13">
                </div>
            </li>
        </ul>
    </div>
</el-dialog>
</template>
<script>
export default {
    name :'GamblersRank',
    props:['status','listArray'],
    computed:{
        user(){
            return this.$store.getters.user;
        }
    },
    data(){
        return {
            list:[1,2,3,4,5,6,7,8,9,10]
        }
    },
    methods:{
        closeHandler(){
            this.$emit('update:status',false)
        }

    }
}
</script>
<style lang="less" scoped>
.ball-style{
    /deep/.el-dialog{width:380px; background: none;}
    /deep/.el-dialog__header{display: none;}
    /deep/.el-dialog__body{
        padding: 0;
    }
}
@media screen and (max-width:768px){
    .ball-style{

        /deep/.el-dialog{width:90%}
    }
}

.ball-cup-container{
    background: url(../assets/dialog-bg.png) no-repeat right top #ff4400; background-size: 100%; padding:15px; position: relative; border-radius: 10px;
    .title-text{
        display: flex; align-items: center; padding: 5px 0 19px;
        .main{margin-right: 10px;}
        .subf{font-size: 14px; line-height: 20px; color: #fff; opacity: 0.8;}
    }
    .win-cup{position: absolute; right: 70px; top: -31px;}
    .close{position: absolute; right: 25px; top: 15px; cursor: pointer;}
}

.list{
    padding: 20px; background: #fff; border-radius: 10px; max-height: 480px; overflow-y:auto;
    li{
        display: flex; align-items: center;
        margin-bottom: 15px;
        .order{width:25px; margin-right: 10px;}
        .user-avatar{width:40px; height: 40px; overflow:hidden; border:1px solid #FFB500; border-radius: 50%; margin-right: 10px;}
        .flex-cont{
            flex: 1; overflow: hidden;
            .user-name{overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: #111; font-size: 14px;}
            .join-total{font-size: 12px; color: #999; margin-top: 10px;}
        }
        .self{background: #FF653B; font-size: 12px; line-height: 20px; padding: 0 5px; border-radius: 2px; color: #fff;}
        .total-count{background: radial-gradient(#f44342, #ff8a7d); display: flex; align-items: center;
                border-radius: 13px; height: 26px; padding:0 5px; font-size: 12px; line-height: 18px; color: #fff; margin-left: 10px;
                img{margin-left: 5px;}
        }
    }
}
</style>